import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { PlanUsageStatus } from "../../Objects/Company/PlanUsageStatus"
import { GetRequest } from "../../services/ApiClientService"

export const usePlanUsage = () => {
  const { setError } = useError()

  const handleGetPlanUsage = async (onSuccess: (status: PlanUsageStatus) => void) => {
    try {
      const response = await GetRequest<PlanUsageStatus>(API_ROUTES.SUBSCRIPTION.USAGE)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new PlanUsageStatus(response.data ?? {}))
    } catch (e: any) {
      const message = e instanceof Error ? e.message : "Erro ao consultar limite do plano."
      setError("Limite do plano", message)
    }
  }

  return {
    handleGetPlanUsage,
  }
}
